export default __webpack_public_path__ + "static/media/android-icon.f2e6f997.svg";